// extracted by mini-css-extract-plugin
module.exports = {"diagram__container":"WorkflowDefinitionDetail_diagram__container__32IqY","diagram__full-screen_button":"WorkflowDefinitionDetail_diagram__full-screen_button__2Fgbe"};